import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render winners count section for FAQ Page
 */
const WinnersCountSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans leading-[1.4]"
      data-testid="winners-count-section-component"
    >
      <AccordionV2
        testId="winners-count"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="1. How many winners will there be, and what can each winner receive?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p className="mt-1">
            <strong>Emerging Enterprise Award</strong>
          </p>

          <p>
            Recognises emerging enterprises that demonstrate an enterprising
            mindset. These are businesses that drive consistent, significant and
            sustainable growth, resulting in excellent business performance,
            while displaying the ability to scale and expand overseas.
          </p>

          <p>
            <strong>Up to 3 winners will each receive:</strong>
          </p>

          <ul className="mb-4 list-outside list-disc pl-8">
            <li>
              From OCBC: a two-year, interest-free term loan of up to S$200,000
              (or local currency equivalent, as set out in the terms and
              conditions);
            </li>
            <li>
              From The Business Times: Media publicity (print, digital, social
              media, radio, and podcasts) for Singapore and the region; and
            </li>
            <li>
              From RSM: &quot;Consulting Package for Growing Businesses&quot;
              worth S$15,000.
            </li>
          </ul>

          <p>
            <strong>
              Most Promising Startup – up to 1 winner will each receive:
            </strong>
          </p>

          <ul className="mb-15 list-outside list-disc pl-8">
            <li>
              From OCBC: a two-year, interest-free term loan of up to S$100,000
              (or local currency equivalent, as set out in the terms and
              conditions); and
            </li>
            <li>
              From The Business Times: Media publicity (print, digital, social
              media, radio, and podcasts) for Singapore and the region
            </li>
          </ul>

          <p>
            <strong>Emerging Enterprise Sustainability Award</strong>
          </p>

          <p>
            Honours businesses that prioritise sustainability, utilise
            technology and innovative solutions for a low-carbon future, and
            capitalise on green-economy growth opportunities.
          </p>

          <p>
            <strong>Up to 3 winners will each receive:</strong>
          </p>

          <ul className="mb-4 list-outside list-disc pl-8">
            <li>
              From OCBC: a two-year, interest-free term loan of up to S$200,000
              (or local currency equivalent, as set out in the terms and
              conditions); and
            </li>
            <li>
              From The Business Times: Media publicity (print, digital, social
              media, radio, and podcasts) for Singapore and the region
            </li>
            <li>
              From RSM: &quot;Consulting Package for Growing Businesses&quot;
              worth S$15,000.
            </li>
          </ul>

          <p>
            <strong>
              Most Promising Sustainability Startup – up to 1 winner will each
              receive:
            </strong>
          </p>

          <ul className="mb-6 list-outside list-disc pl-8">
            <li>
              From OCBC: a two-year, interest-free term loan of up to S$100,000
              (or local currency equivalent, as set out in the terms and
              conditions); and
            </li>
            <li>
              From The Business Times: Media publicity (print, digital, social
              media, radio, and podcasts) for Singapore and the region
            </li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default WinnersCountSection;
